
export const TODAY_TYPE = 'Today';
export const THIS_WEEK_TYPE = 'ThisWeek';
export const THIS_MONTH_TYPE = 'ThisMonth';
export const THIS_YEAR_TYPE = 'ThisYear';
export const getEventTemplateDashboard = (eventTemplate = {}) => ({
  ...eventTemplate,
  eventTemplate,
  dashboardData: {
    endDate: null,
    includeArchived: false,
    includeComplete: false,
    searchText: '',
    startDate: null,
    statusIds: [],
    tagConditions: [[]],
    eventTemplateId: eventTemplate.id,
  },
  directLinkName: `workflows/${eventTemplate.id}`,
  id: `workflow-dashboard-${eventTemplate.id}`,
  organizationExposed: true,
});

